import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import { FlexMixin } from "@zillow/constellation";
import styled, { css } from "styled-components";
import CarouselTab from "./CarouselTab.esm.js";
import CustomPropTypes from "../../utils/custom-prop-types.esm.js";
import { ARROW_COLUMN_WIDTH } from "./CarouselNavigation.esm.js";
const SlideContainer = styled.div.withConfig({
  displayName: "CarouselItem__SlideContainer",
  componentId: "sc-10wga22-0"
})(["display:flex;flex-direction:column;width:100%;overflow:hidden;", ""], FlexMixin);
const ArrowSpacer = styled.div.withConfig({
  displayName: "CarouselItem__ArrowSpacer",
  componentId: "sc-10wga22-1"
})(["display:flex;flex-shrink:0;width:100%;", ""], (props) => props.showArrows ? css(["padding:0 ", ";"], ARROW_COLUMN_WIDTH) : "");
function CarouselItem({
  privateRenderType,
  ...props
}) {
  switch (privateRenderType) {
    case "slide": {
      return /* @__PURE__ */ jsx(ArrowSpacer, { showArrows: props.showArrows, children: /* @__PURE__ */ jsx(SlideContainer, { ...props }) });
    }
    case "tab":
      return /* @__PURE__ */ jsx(CarouselTab, { ...props, children: props.tab || "Tab" });
    default:
      return null;
  }
}
CarouselItem.displayName = "Carousel.Item";
CarouselItem.propTypes = {
  alignItems: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(["stretch", "center", "flex-start", "flex-end", "baseline"])),
  justifyContent: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly", "initial", "inherit"])),
  /** If showTabs is true on <Carousel> this is the related text for
   * the tab for this slide. If left undefined it will default to read "Tab".
   */
  tab: PropTypes.string,
  /**
   * This is only set by <Carousel> - dev's should not set this.
   * Dev's should leave this undefined.
   */
  privateRenderType: PropTypes.oneOf(["slide", "tab"]),
  /**
   * If should have padding for arrows.
   */
  showArrows: PropTypes.bool
  /**
   * All other props passed, get passed to the reendered element. Like when
   * "slide" it will send the motion props to the slide.
   */
};
export {
  CarouselItem as default
};
